<template>
    <div id="visitor-history" class="container-fluid pl-0 pr-0">
        <b-row id="visitor-history-row">
            <b-col cols="2">
                <b-form-group
                    id="start-date-input-group"
                    :label="$t('message.first')"
                    class="mb-1 custom-input"
                    label-for="start-date-input"
                    label-sr-only
                >
                    <datetime
                        v-model="startDate"
                        :max-datetime="maxDate"
                        :min-datetime="lastFiveYear"
                        :phrases="phrases"
                        :placeholder="$t('message.startDate')"
                        auto
                        input-class="form-control rounded-0"
                        input-id="start-date-input"
                        type="datetime"
                    />
                </b-form-group>
            </b-col>
            <b-col cols="2">
                <b-form-group
                    id="end-date-input-group"
                    :label="$t('message.last')"
                    class="mb-1 custom-input"
                    label-for="end-date-input"
                    label-sr-only
                >
                    <datetime
                        v-model="endDate"
                        :max-datetime="maxDate"
                        :min-datetime="lastFiveYear"
                        :phrases="phrases"
                        :placeholder="$t('message.endDate')"
                        auto
                        input-class="form-control rounded-0"
                        input-id="end-date-input"
                        type="datetime"
                    />
                </b-form-group>
            </b-col>
            <b-col cols="2">
                <b-form-group
                    id="query-input-group"
                    :label="$t('message.query')"
                    class="mb-1 custom-input"
                    label-for="query-input"
                    label-sr-only
                >
                    <b-form-input
                        id="query-input"
                        v-model="query"
                        :placeholder="$t('message.query')"
                        class="rounded-0"
                        name="query"
                    />
                </b-form-group>
            </b-col>
            <b-col class="custom-input">
                <a-rate v-model="point" :allow-clear="true" />
            </b-col>
            <b-col cols="2">
                <b-form-group class="mb-1 custom-input">
                    <b-form-select v-model="selectedUser" class="mb-3">
                        <option :value="null">
                            {{ $t("message.allUsers") }}
                        </option>
                        <option v-for="item in usersFilter.data" :key="item._id" :value="item._id">
                            {{ item.name }}
                        </option>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col cols="2">
                <b-form-group id="query-input-group3" class="mb-1 custom-input">
                    <b-form-select v-model="selectedCustomerDomains" class="mb-3">
                        <option :value="null">
                            {{ $t("message.allSites") }}
                        </option>
                        <option v-for="site in customerDomains" :key="site" :value="site">
                            {{ site }}
                        </option>
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <vue-excel-xlsx
            :columns="getFields()"
            :data="getExcellData()"
            :filename="getFileName()"
            :sheetname="'Sayfa 1'"
            class="excel-style"
        >
            <md-icon>download</md-icon>
        </vue-excel-xlsx>
        <a-table
            :key="'vh-table-' + renderCount"
            :columns="getCols()"
            :dataSource="visitors.data"
            :loading="loading"
            :locale="{
                emptyText: $t('message.noVisitorFound'),
            }"
            :pagination="false"
            class="custom-table"
            rowKey="_id"
            size="small"
            @change="tableChange"
        >
            <div v-for="(input, i) in customLoginInputs" :key="i" :slot="input._id" slot-scope="data" class="ellipsis">
                {{ getInputValue(data, input) }}
            </div>
            <div slot="_country" slot-scope="data, item">
                {{ item.geoLocation ? item.geoLocation.country : "N/A" }}
            </div>
            <div slot="_createdDate" slot-scope="data, item">
                {{ item.createdDate | dateShorted }}
            </div>
            <div slot="_destroyedDate" slot-scope="data, item">
                {{ item.destroyedDate | dateShorted }}
            </div>
            <div slot="_timeSpent" slot-scope="data, item">
                <PassedTimeCounterTimeFormat :date="item.connectedDate" :endDate="item.destroyedDate" />
            </div>
            <div slot="_star" slot-scope="data, item">
                {{ item.point || "-" }}
            </div>
            <div slot="_user" slot-scope="data, item"
                 v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                            theme: isDarkMode ? 'light-border' : 'google',
                          }"
                 :content="getUserNames(item)"
            >
                {{ getUserNames(item).length >15 ? getUserNames(item).slice(0,11) + "..." : getUserNames(item) }}
            </div>
            <div slot="_actions" slot-scope="data, item">
                <a-button
                    class="actionButton d-flex align-items-center"
                    size="small"
                    @click="view(item._id, item.index)"
                >
                    <span style="margin-right: 3px; display: block; font-size: 12px">{{ $t("message.detail") }}</span>
                    <SearchIcon />
                </a-button>
            </div>
        </a-table>

        <b-modal
            v-if="'undefined' !== typeof selectedHistory.visitor._id"
            id="history-details"
            :title="$t('message.historyDetails')"
            centered
            hide-footer
            @hidden="reset"
        >
            <b-tabs content-class="mt-3">
                <b-tab :title="$t('message.chat')" active>
                    <div v-if="filteredMessages.length" style="display: flex; flex-direction: column">
                        <vue-excel-xlsx
                            :columns="downloadConversationFields()"
                            :data="downloadConversationData()"
                            :filename="downloadConversationName"
                            :sheetname="'Page 1'"
                            class="md-button"
                            style="justify-self: end; width: 36px; align-self: center"
                        >
                            <md-icon>download</md-icon>
                        </vue-excel-xlsx>
                        <div v-if="filteredMessages.length" v-chat-scroll class="messages">
                            <MessageList
                                :always-scroll-to-bottom="false"
                                :colors="colors"
                                :messages="getMessages()"
                                :participants="getParticipants()"
                            />
                        </div>
                    </div>
                    <div v-else>
                        <b-alert show variant="info">{{ $t("message.chatNotFound") }}</b-alert>
                    </div>
                </b-tab>
                <b-tab v-if="selectedHistory.visitor.visitor" :title="$t('message.visitorInfo')">
                    <div class="userInfo">
                        <div class="userInfo first">
                            {{ $t("message.fullName") }}
                        </div>
                        <div
                            v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                            theme: isDarkMode ? 'light-border' : 'google',
                                        }"
                            :content="selectedHistory.visitor.fullname"
                            class="userInfo sec">
                            {{ selectedHistory.visitor.fullname }}
                        </div>
                    </div>
                    <div class="userInfo">
                        <div class="userInfo first">
                            {{ $t("message.email") }}
                        </div>
                        <div
                            v-tippy="{
                                            followCursor: true,
                                            placement: 'bottom-end',
                                            theme: isDarkMode ? 'light-border' : 'google',
                                        }"
                            :content=" selectedHistory.visitor.email "
                            class="userInfo sec">
                            {{ selectedHistory.visitor.email }}
                        </div>
                    </div>
                    <div class="userInfo">
                        <div class="userInfo first">IP</div>
                        <div class="userInfo sec">
                            {{ selectedHistory.visitor.ipAddress || "-" }}
                        </div>
                    </div>

                    <div v-if="getSubjectName(selectedHistory.visitor.subject)" class="userInfo">
                        <div class="userInfo first">
                            {{ $t("message.department") }}
                        </div>
                        <div class="userInfo sec">
                            {{ getSubjectName(selectedHistory.visitor.subject) }}
                        </div>
                    </div>
                    <div class="userInfo">
                        <div class="userInfo first">{{ $t("message.visitingPage") }}</div>
                        <div class="userInfo sec">
                            {{ selectedHistory.visitor.visitor.visitingPage || "-" }}
                        </div>
                    </div>
                    <div class="userInfo">
                        <div class="userInfo first">{{ $t("message.country") }} & {{ $t("message.city") }}</div>
                        <div class="userInfo sec">
                            {{ selectedHistory.visitor.geoLocation.country || selectedHistory.visitor.visitor.country }}
                            -
                            {{ selectedHistory.visitor.visitor.city || "-" }}
                        </div>
                    </div>
                    <div class="userInfo">
                        <div class="userInfo first">
                            {{ $t("message.browser") }}
                        </div>
                        <div class="userInfo sec">
                            {{ selectedHistory.visitor.visitor.browser || "-" }}
                        </div>
                    </div>
                    <div class="userInfo">
                        <div class="userInfo first">{{ $t("message.os") }}</div>
                        <div class="userInfo sec">
                            {{ selectedHistory.visitor.visitor.os || "-" }}
                        </div>
                    </div>
                    <div v-if="$_.get(selectedHistory, 'visitor.note.representativeNote', false)" class="userInfo">
                        <div class="userInfo first">{{ $t("message.feedback") }}</div>
                        <div class="userInfo sec">
                            {{ selectedHistory.visitor.note.representativeName }}:{{
                                selectedHistory.visitor.note.representativeNote
                            }}
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </b-modal>
        <div style="display: flex; justify-content: flex-end; margin-top: 6px">
            <Pagination
                :page-change="pageChange"
                :pageSizes="pageSizes"
                :total="visitors.total"
                pageSizeLocalStorageKey="visitor-history-page-size"
            />
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { Settings } from "luxon";
import { mapActions, mapGetters, mapState } from "vuex";
import * as _ from "lodash";
import MessageList from "./popup-chat/MessageList";
import { log2 } from "../utils/log2";
import { toNewMessagesModel } from "../utils/chat";
import PassedTimeCounterTimeFormat from "./PassedTimeCounterTimeFormat";
import { tableSorter } from "../utils/utils";
import Pagination from "./Pagination";
import SearchIcon from "./svg/SearchIcon";
import { i18n } from "../language";
import { getPersistenceData } from "../utils/persistenceStorage";

Settings.defaultLocale = i18n.locale;
const log = log2("VisitorHistory");

const defaultStartDate = moment().startOf("day").toISOString();
const defaultEndDate = moment().endOf("day").toISOString();
export default {
    name: "VisitorHistory",
    props: {
        timeSelect: { type: String },
    },
    components: {
        Pagination,
        MessageList,
        PassedTimeCounterTimeFormat,
        SearchIcon,
    },
    data() {
        return {
            selectedCustomerDomains: null,
            renderCount: 0,
            point: undefined,
            currentSort: {
                columnKey: "createdDate",
                order: "ascend",
            },
            rowIndex: 0,
            pageSizes: ["10", "25", "50", "100"],
            usersFilter: [],
            selectedUser: null,
            selectedHistory: {
                visitor: {},
                messages: [],
            },
            loading: true,
            startDate: defaultStartDate,
            endDate: defaultEndDate,
            query: null,
            maxDate: moment().toISOString(),
            lastFiveYear: moment().subtract(5, "year").toISOString(),
            selectedCustomDateFilter: "today",
            pageSize: !isNaN(getPersistenceData("visitor-history-page-size") || "undefined")
                ? parseInt(getPersistenceData("visitor-history-page-size"))
                : 10,
            current: 1,
            phrases: {
                ok: this.$t("message.ok"),
                cancel: this.$t("message.cancel"),
            },
            colors: {
                header: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                launcher: {
                    bg: "#4e8cff",
                },
                messageList: {
                    bg: "#ffffff",
                },
                sentMessage: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                receivedMessage: {
                    bg: "#eaeaea",
                    text: "#222222",
                },
                userInput: {
                    bg: "#f4f7f9",
                    text: "#565867",
                },
            },
        };
    },
    computed: {
        ...mapState({
            visitors: (state) => state.visitor.visitors,
            users: (state) => state.user.users.data,
            customLoginInputs: (state) => state.customLoginForm.inputs,
            subjects: (state) => state.subject.subjects.data,
            site: (state) => state.site.site,
            customerDomains: (state) => state.visitor.customerDomains,
            selectedSubject: (state) => state.subject.selectedSubject,
        }),
        ...mapGetters({
            getUser: "user/getUser",
            isCustomLoginFormEnabled: "customLoginForm/isCustomLoginFormEnabled",
            isDarkMode: "user/isDarkMode",
        }),
        filteredMessages() {
            log(
                "filteredMessages",
                this.selectedHistory.messages,
                this.selectedHistory.messages.filter((m) => "undefined" === typeof m.type)
            );
            return this.selectedHistory.messages.filter((m) => "undefined" === typeof m.type);
        },
        downloadConversationName() {
            return `${this.selectedHistory.visitor.fullname}-${moment(this.selectedHistory.visitor.createdDate).format(
                "DD MMM, HH-mm-ss"
            )}`;
        },
    },
    methods: {
        ...mapActions({
            getVisitors: "visitor/getVisitors",
            loadOldMessages: "chat/loadOldMessages",
            getUsers: "user/getUsers",
            getCustomerDomains: "visitor/getCustomerDomains",
        }),
        getCols() {
            log("ınputlar bunlar", this.customLoginInputs);
            let cols = [
                {
                    title: this.$t("message.country"),
                    scopedSlots: { customRender: "_country" },
                    slot: "country",
                    key: "geoLocation.country",
                    ...tableSorter("geoLocation.country", "string", this.currentSort),
                },
                {
                    title: this.$t("message.start"),
                    scopedSlots: { customRender: "_createdDate" },
                    slot: "createdDate",
                    key: "createdDate",
                    ...tableSorter("createdDate", "date", this.currentSort),
                },
                {
                    title: this.$t("message.finish"),
                    scopedSlots: { customRender: "_destroyedDate" },
                    slot: "destroyedDate",
                    key: "destroyedDate",
                    ...tableSorter("destroyedDate", "date", this.currentSort),
                },
                {
                    title: this.$t("message.timeSpent"),
                    scopedSlots: { customRender: "_timeSpent" },
                    key: "timeSpent",
                    slot: "timeSpent",
                    ...tableSorter(
                        (row) => {
                            return moment
                                .duration(moment(row.destroyedDate).diff(moment(row.createdDate)), "seconds")
                                .asSeconds();
                        },
                        "number",
                        this.currentSort,
                        "timeSpent"
                    ),
                },
                {
                    title: this.$t("message.representative_"),
                    scopedSlots: { customRender: "_user" },
                    slot: "user",
                },
                {
                    title: this.$t("message.star"),
                    scopedSlots: { customRender: "_star" },
                    slot: "star",
                    key: "star",
                    ...tableSorter(
                        (row) => {
                            return row.point ? row.point : 0;
                        },
                        "number",
                        this.currentSort,
                        "star"
                    ),
                },
                {
                    title: this.$t("message.transactions"),
                    key: "actions",
                    scopedSlots: { customRender: "_actions" },
                    slot: "actions",
                },
            ];
            if (this.isCustomLoginFormEnabled) {
                let customCols = this.customLoginInputs.map((x) => {
                    return {
                        title: x.localizedLabel[i18n.locale].text,
                        scopedSlots: { customRender: x._id },
                        name: x.name,
                        ...tableSorter("x.name", "string", this.currentSort),
                    };
                });
                cols = [...customCols, ...cols];
            } else {
                cols = [
                    {
                        title: this.$t("message.fullName"),
                        dataIndex: "fullname",
                        key: "fullname",
                        ...tableSorter("fullname", "string", this.currentSort),
                    },
                    {
                        title: this.$t("message.email"),
                        dataIndex: "email",
                        key: "email",
                        ...tableSorter("email", "string", this.currentSort),
                    },
                    ...cols,
                ];
            }
            log.debug("getCols called", { cols });
            return cols;
        },
        getSubjectName(id) {
            let maybeSubject = this.subjects.find((x) => x._id == id);
            return maybeSubject ? maybeSubject.languageContent[i18n.locale].name : undefined;
        },
        getInputValue(data, input) {
            let maybeInput = (data.customLoginInfos || []).find((x) => x.input === input._id);
            if (maybeInput) {
                let inputSchema = this.customLoginInputs.find((x) => x._id === input._id);
                if (inputSchema.type === "subject") {
                    return this.getSubjectName(maybeInput.value);
                }
                return maybeInput.value;
            }
            if (input.type === "email") return data.email || "-";
            if (input.type === "fullname") return data.fullname || "-";
            return "-";
        },
        tableChange(pagination, filters, sorter) {
            /*log("tableChange", {pagination, filters, sorter});*/
            const newSort = {
                columnKey: sorter.columnKey,
                order: sorter.order,
            };
            const oldSort = this.currentSort;
            log.debug("sort debug", {
                oldSort: { ...oldSort },
                newSort: { ...newSort },
                eq: _.isEqual(newSort, oldSort),
            });
            if (!_.isEqual(newSort, oldSort)) {
                this.currentSort = newSort;
                log.debug("sort changed", {
                    newSort,
                });
                this.renderCount += 1;
                this.$forceUpdate();
            }
        },
        setCustomDateFilter(filter) {
            log.debug("setCustomDateFilter ", filter);
            this.selectedCustomDateFilter = filter;
            if (filter === "today") {
                this.startDate = moment().startOf("day").toISOString();
                this.endDate = moment().endOf("day").toISOString();
            } else if (filter === "yesterday") {
                this.startDate = moment().subtract(1, "days").startOf("day").toISOString();
                this.endDate = moment().subtract(1, "days").endOf("day").toISOString();
            } else if (filter === "current-week") {
                this.startDate = moment().startOf("week").startOf("day").toISOString();
                this.endDate = moment().endOf("day").toISOString();
            } else if (filter === "last-week") {
                this.startDate = moment().startOf("isoWeeks").subtract(1, "days").startOf("isoWeeks").toISOString();
                this.endDate = moment().startOf("isoWeeks").subtract(1, "days").endOf("isoWeeks").toISOString();
            } else if (filter === "current-month") {
                this.startDate = moment().startOf("month").startOf("day").toISOString();
                this.endDate = moment().endOf("day").toISOString();
            } else if (filter === "last-month") {
                this.startDate = moment().startOf("month").subtract(1, "days").startOf("month").toISOString();
                this.endDate = moment().startOf("month").subtract(1, "days").endOf("month").toISOString();
            } else if (filter === "last-30") {
                this.startDate = moment().subtract(30, "days").startOf("day").toISOString();
                this.endDate = moment().endOf("day").toISOString();
            } else if (filter === "all-time") {
                this.startDate = null;
                this.endDate = null;
            }
        },
        getUserNames(item) {
            return (item.users && item.users.length > 0 ? _.uniqBy(item.users, (q) => q._id) : [item.connectedUser])
                .map((x) => this.getUserName(x))
                .join(" ; ");
        },
        getUserName(userObjectOrUserId) {
            if (!userObjectOrUserId) return "-";
            const isUserObject = typeof userObjectOrUserId === "object";
            const isUserId = typeof userObjectOrUserId === "string";
            if (isUserObject) {
                return userObjectOrUserId.name;
            } else if (isUserId) {
                let newUser = "-";
                const maybeUserObj = this.users !== null && this.users.find((x) => x._id === userObjectOrUserId);
                if (maybeUserObj) {
                    newUser = maybeUserObj.name;
                }
                log("getUserHelper", userObjectOrUserId, newUser, maybeUserObj);
                return newUser;
            } else {
                return "-";
            }
        },
        getParticipants() {
            const supportUsers = this.filteredMessages
                .filter((x) => x.messageType === "user" || x.messageType === "private")
                .map((x) => ({
                    id: x.userId,
                    name: x.username,
                }));

            return _.uniqBy(supportUsers, (q) => q.name);
        },
        getMessages() {
            let allMessages = toNewMessagesModel(this.filteredMessages, this);

            if (this.typingMessage) {
                allMessages = [
                    ...allMessages,
                    {
                        type: "typing",
                        data: {
                            text: this.typingMessage,
                        },
                    },
                ];
            }

            return allMessages;
        },
        resetFilters() {
            this.startDate = null;
            this.endDate = null;
            this.query = null;

            this.getHistory();
        },
        getHistory(resetPage = false) {
            if (resetPage) {
                this.current = 1;
            }

            this.loading = true;
            log("getHistory running ", { query: this.query });
            this.getVisitors({
                perPage: this.pageSize,
                page: this.current,
                startDate: this.startDate,
                endDate: this.endDate,
                query: this.query,
                point: this.point,
                userId: this.selectedUser,
                homeSite: this.selectedCustomerDomains,
            })
                .then()
                .finally(() => (this.loading = false));
        },
        view(id, i) {
            this.selectedHistory.visitor = this.visitors.data.find((v) => v._id === id);
            this.rowIndex = i;
            this.loadOldMessages(id).then((response) => {
                let items = response.data.data;
                items = _.orderBy(
                    _.uniqBy(items, (q) => q.uniqMessageId || q._id),
                    (q) => moment(q.createdDate).toDate().getTime(),
                    "asc"
                );
                this.selectedHistory.messages = items;
                this.$bvModal.show("history-details");
            });
        },
        downloadConversationData() {
            let rawData = this.selectedHistory.messages.filter(
                (x) => x.messageType === "visitor" || x.messageType === "user"
            );
            let formattedData = rawData.map((x) => {
                let name;
                let date = moment(x.createdDate).format("HH:mm:ss");
                let message = (x.description || "").replace(/(<([^>]+)>)/gi, "");
                if (x.messageType === "visitor") {
                    name = this.selectedHistory.visitor.fullname;
                } else {
                    name = `${x.username}(${this.$t("message.representative_")})`;
                }
                return {
                    name: name,
                    date: date,
                    message: message,
                };
            });
            return formattedData;
        },
        downloadConversationFields() {
            return [
                {
                    label: this.$t("message.username"),
                    field: "name",
                },
                {
                    label: this.$t("message.date"),
                    field: "date",
                },
                {
                    label: this.$t("message.message"),
                    field: "message",
                },
            ];
        },
        reset() {
            this.selectedHistory = {
                visitor: {},
                messages: [],
            };
        },
        rowClass(item, type) {
            if (item && type === "row") {
                if (this.selectedHistory.visitor._id === item._id) {
                    return "table-active";
                } else {
                    return null;
                }
            } else {
                return null;
            }
        },
        onShowSizeChange(current, pageSize) {
            log("onShowSizeChange", current, pageSize);
            this.current = current;
            this.pageSize = pageSize;
            this.getHistory();
        },
        pageChange(page, pageSize) {
            log("pageChange", page, pageSize, typeof page);
            this.current = page;
            this.pageSize = pageSize;
            this.getHistory();
        },
        fetchAllUsers() {
            this.getUsers({ perPage: 100, page: 1 }).then((response) => {
                log("getUsers completed", response.data);
                this.usersFilter = response.data;
            });
        },
        queryChanged: _.debounce(function (newQuery, oldQuery) {
            log("queryChanged", { newQuery, oldQuery });
            if (newQuery !== oldQuery) {
                this.page = 1;
                this.getHistory(true);
            }
        }, 1000),
        getFields() {
            let cols = this.getCols()
                .map((x) => {
                    let key = x.name || x.key || x.slot;
                    key = key === "geoLocation.country" ? "country" : key;
                    key = key === "star" ? "point" : key;
                    return {
                        key,
                        field: key,
                        label: x.title,
                    };
                })
                .filter((x) => x.key !== "actions");
            return [
                {
                    key: "_id",
                    field: "_id",
                    label: "Chat ID",
                },
                {
                    field: "subject",
                    label: this.$t("message.department"),
                },
                ...cols,
            ];
        },
        getExcellData() {
            return this.visitors.data.map((x) => ({
                ...x,
                ...(x.customLoginInfos || []).reduce((acc, cur) => {
                    let maybeInputMeta = this.customLoginInputs.find(
                        (customLoginInput) => customLoginInput._id === cur.input
                    );
                    if (maybeInputMeta) {
                        acc[maybeInputMeta.name] = cur.value;
                    }
                    return acc;
                }, {}),
                country: x.geoLocation ? x.geoLocation.country : "N/A",
                user: this.getAgentNames(x) || "-",
                createdDate: moment(x.createdDate).format("DD MMM, HH:mm:ss"),
                destroyedDate: x.destroyedDate ? moment(x.destroyedDate).format("DD MMM, HH:mm:ss") : "-",
                timeSpent: x.destroyedDate
                    ? Math.ceil(moment.duration(moment(x.destroyedDate).diff(x.createdDate)).asMinutes()) + "dk"
                    : "-",
                subject: this.getSubjectName(x.subject),
            }));
        },
        getFileName() {
            return "Ziyaretçi Geçmişi - " + moment().format("DD MMM, HH-mm");
        },
        getAgentNames(chat) {
            return chat.users
                .map((id) => {
                    const u = this.users.find((x) => x._id === id);
                    return u ? u.name : "";
                })
                .join(",");
        },
    },
    mounted() {
        log("momentlocale", moment.locale(), "this.$i18n.locale", this.$i18n.locale);
        log("visitor history", this.isCustomLoginFormEnabled);
        log("visitor history data ", this.visitors.data);
        this.setCustomDateFilter(this.timeSelect);
        moment.locale(this.$i18n.locale);
        this.fetchAllUsers();
        this.getHistory();
        window.addEventListener("keydown", (e) => {
            if (e.key === "ArrowDown" && (e.ctrlKey || e.metaKey)) {
                if (this.rowIndex < 10) {
                    this.view(this.visitors.data[this.rowIndex + 1]._id, this.rowIndex + 1);
                }
                e.preventDefault();
            } else if (e.key === "ArrowUp" && (e.ctrlKey || e.metaKey)) {
                if (this.rowIndex > 0) {
                    this.view(this.visitors.data[this.rowIndex - 1]._id, this.rowIndex - 1);
                }
                e.preventDefault();
            }
        });
        this.getCustomerDomains();
    },
    updated() {
        if (moment.locale() !== this.$i18n.locale) moment.locale(this.$i18n.locale);
        log("visitor history data ", this.visitors.data);
    },
    watch: {
        startDate(newValue, oldValue) {
            if (newValue) {
                log("startDate updated", newValue);
                this.page = 1;
                this.getHistory(true);
            }
        },
        endDate(newValue, oldValue) {
            if (newValue) {
                log("endDate updated", newValue);
                this.page = 1;
                this.getHistory(true);
            }
        },
        selectedUser(newValue, oldValue) {
            log("selectedUser updated", newValue);
            this.page = 1;
            this.getHistory(true);
        },
        query(newValue, oldValue) {
            log("query updated", newValue);
            this.queryChanged(newValue, oldValue);
            this.query = newValue;
        },
        point(newValue, oldValue) {
            log("query updated", newValue);
            this.point = newValue;
            this.getHistory(true);
        },
        pageSize(newValue) {
            log("pageSize", newValue);
            this.pageSize = newValue;
            this.getHistory();
        },
        current(newValue) {
            log("current", newValue);
            this.current = newValue;
            this.getHistory();
        },
        timeSelect(newVal, oldVal) {
            this.setCustomDateFilter(newVal);
        },
        selectedCustomerDomains(newVal) {
            this.getHistory();
        },
        selectedSubject() {
            this.getHistory(true);
        },
    },
};
</script>

<style lang="scss">
.new-theme {
    .custom-input input,
    .custom-input ul,
    .custom-input select {
        background-color: #ffffff;
        border: none;
        border-radius: 6px !important;
        height: 30px;
    }

    .actionButton {
        border: none;
        box-shadow: none;
    }

    .custom-input ul {
        padding: 4px 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
    }

    #visitor-history {
        .excel-style {
            border: none;
            position: inherit;
            right: -25px;
            top: 2px;
            background: bottom;
        }
    }

    #visitor-history-row {
        .col {
            :not(:last-child) {
                padding-right: 5px !important;
            }
        }
    }
}
</style>
<style lang="scss">
.userInfo {
    font-family: Poppins;

    &.first {
        color: #3699ff;
        font-size: 16px;
        font-weight: 500;
        padding-top: 15px;
        line-height: 1;
    }

    &.sec {
        color: #181c32;
        font-size: 14px;
        font-weight: 300;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        max-width: 300px;
        -webkit-box-orient: vertical;
    }
}
</style>

<style lang="scss" scoped>
.ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    max-width: 300px;
    -webkit-box-orient: vertical;
}
</style>
